import './index.scss'

/* import Swiper core, modules, and css */
import Swiper from 'swiper';
import { Navigation, Scrollbar, Parallax } from 'swiper/modules'; // import Swiper modules (when needed). Full list available here: https://swiperjs.com/swiper-api#modules
import { toggleSwiperLock } from './../../js/toggleSwiperLock'

/* global fetch */
class Team {
  constructor(el) {
    this.$el = el
    
    // console.log('Team::constructor')
  }
  init() {
    // console.log('Team::init')
    
    this.initSwiper()
  }
  initSwiper() {
    const modules = [Navigation, Scrollbar]
    
    this.swiper = new Swiper(this.$el.querySelector('.oce-team__swiper'), {
      slidesPerView: 'auto',
      modules: modules,
      
      navigation: {
        prevEl: '[data-swiper-prev]',
        nextEl: '[data-swiper-next]',
      },
      
      scrollbar: {
        draggable: false,
        hide: false,
        el: '[data-swiper-scrollbar]'
      },
      
      spaceBetween: 16,
      
      breakpoints: {
        992: {
          spaceBetween: 24
        }
      },
      
      on: {
        init: function(swiper) {
          return toggleSwiperLock(swiper)
        },
        // click: function (swiper) {
        //   swiper.slideTo(this.clickedIndex, 1000)  
        // },
        resize: function(swiper) {
          return toggleSwiperLock(swiper)
        },
      },
      preventClicks: true,
      slideToClickedSlide: false,
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-team') ].forEach($block => {
        $block.expandygg = new Team($block)
    })
}, {capture: false, passive: true, once: true} || false)
